import React, { ChangeEvent, ReactElement, useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { IAppState } from '../../../core/store/store'
import {
  Button,
  ButtonType,
  Card,
  CardContainer,
  CardContent,
  CardSizeTypes,
  Checkbox,
  Form,
  FormFieldSize,
  FormGroup,
  Input,
  MultiSelect,
  Select,
  SubmitButton,
  Icon, InputType,
} from '@digicert/dcone-common-ui'
import styles from './CreateUserWithRole.module.scss'
import { Translate } from 'react-localize-redux'
import { serviceIcon, translate, } from '../../../shared/helpers/utils'
import { ExtendedCreateUserProps } from './CreateUserWithRole.types'
import NoPermissionsPage from '../../../shared/components/no-permissions-page'
import { EMAIL_REGEXP, NAME_REGEXP, RouterConfig, USER_NAME_REGEXP } from '../../../core/utils/constants'
import { IAccessScope, IApplication } from '../../../reducers/Reducers.interfaces'
import { createUser, fetchGroups } from '../../../core/actions/Users.actions'
import history from 'core/history/history'
import { checkIfUsernameExists } from 'public-pages/self-service-user/SelfServiceUser.actions'
import { fetchTenants, fetchTenantById } from 'secure-pages/tenants/Tenants.actions'
import { CERT_CENTRAL_SHORT_APP_CODE, CreateUserTypes } from 'core/constants'
import { IOptions } from '../edit-user-with-role/EditUserWithRole.types'
import { faBuilding } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CreateUserWithRole = (
    {
      checkIfUsernameExists,
      createUser,
      fetchGroups,
      fetchTenants,
      fetchTenantById,
      profileAccessScope,
      permissions,
      profile,
      userCreationType,
      onCreate,
      onCancel
    }: ExtendedCreateUserProps): ReactElement => {
  const accountMessage = [{
    label: translate('common.form.searchAccount') as string,
    value: "-1",
    disabled : true
  }];
  const limit = 10;
  const [offset, setOffset] = useState(0)
  const [total, setTotal] = useState(0)
  const [account, setAccount] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [userName, setUserName] = useState('')
  const [samlUsername, setSamlUsername] = useState('')
  const [oidcUsername, setOidcUsername] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [language, setLanguage] = useState(translate('common.form.select') as string)
  const [userNameExists, setUserNameExists] = useState(false)
  const [groups, setGroups] = useState<string[]>([])
  const [options, setOptions] = useState([])
  const [applications, setApplications] = useState<string[]>([])
  const [appOptions, setAppOptions] = useState<any>([])
  const [signInMethods, setSignInMethods] = useState<any>([]);
  const [certCentralSpAccounts, setCertCentralSpAccounts] = useState<IOptions[]>()
  const [selectedSpCertCentralSpAccounts, setSelectedSpCertCentralSpAccounts] = useState<string[]>()
  const [certCentralId, setCertCentralId] = useState<string>('')
  const [selectedServices, setSelectedServices] = useState<IApplication[]>([])
  const [allAccounts, setAllAccounts] = useState<any>(accountMessage);
  const [accountName, setAccountName] = useState('');
  const [isLoading, setLoading] = useState(false)

  const getAccounts = () => {
    const options = profile?.accounts.filter(account => account.active).map((account) => {
      return {
        label: account.display_name,
        value: account.id,
        locale: account.locale,
        featureIds: account.enabled_feature_ids
      }
    })
    options?.sort((a, b) => (a.label > b.label ? 1 : -1))
    return options
  }

  const getServices = () => {
    const services = profile?.applications
    const servicesArray: Array<any> = []
    if (appOptions.length > 0) {
      appOptions.map(appOption => {
        const app = {
          name: appOption.label,
          id: appOption.value,
          short_app_code: appOption.short_app_code,
        }
        servicesArray.push(app)
      })

    } else if(services) {
      Object.getOwnPropertyNames(services).map((key: string) => {
        const item = services[key]
        if(item) {
          servicesArray.push(item)
        }
      });
    }
    return servicesArray
  }

  const onAccountChange = (value) => {
    typeof value === 'undefined' ? setAccount(translate('common.form.searchAccount') as string) : setAccount(value)
    if(typeof value !== 'undefined' && value !== '-1'){
      setApplications([]);
      setSelectedServices([])
      setSelectedSpCertCentralSpAccounts([])
      fetchTenantById(value).then((tenant: any) => {
        if (tenant) {
          setAppOptions(tenant.applications.map(app => {
            if(app.short_app_code === CERT_CENTRAL_SHORT_APP_CODE) {
              if (app.service_provider_accounts) {
                const spOptions = app.service_provider_accounts.map(acc => {
                  return {
                    value: acc.id,
                    label: acc.source_account_name + ' - ' + acc.source_account_friendly_identifier
                  }
                })
                setCertCentralSpAccounts(spOptions)
              }
            }
            return {
              label: app.name,
              value: app.id,
              short_app_code: app.short_app_code
            }
          }))
          setLanguage(tenant.locale)
          setSignInMethods(tenant.sign_in_methods)
        }
      })
    }
  }

  const onFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFirstName(event.target.value)
  }

  const onLastNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLastName(event.target.value)
  }

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const getAccessScope = () => {
    if (userCreationType === CreateUserTypes.DIGICERT_USER) {
      return IAccessScope.system.toUpperCase()
    } else if (userCreationType === CreateUserTypes.ACCOUNT_USER) {
      return IAccessScope.account.toUpperCase()
    }
    return ''
  }

  const onUserNameFocus = () => {
    if (userName === '') {
      setUserName(email)
      checkIfUsernameExists(email, undefined, undefined, undefined, getAccessScope()).then((response:boolean) => {
        setUserNameExists(response)
      })
    }
    else {
      setUserName(userName)
    }
  }
  const onSamlUsernameFocus = () => {
    if (samlUsername === '') {
      setSamlUsername(email)
    }
    else {
      setSamlUsername(samlUsername)
    }
  }

  const onOidcUsernameFocus = () => {
    if (oidcUsername === '') {
      setOidcUsername(email)
    }
    else {
      setOidcUsername(oidcUsername)
    }
  }

  const validateUserName = (): any => {
    if (userNameExists) {
      return translate('notifications.exceptions.USERNAME_EXISTS') as string;
    }
  }

  const onUserNameChange = useCallback(
      (event) => {
        setUserName(event.target.value)
        checkIfUsernameExists(event.target.value, undefined, undefined, undefined, getAccessScope()).then((response:boolean) => {
          setUserNameExists(response)
        })
      },
      [checkIfUsernameExists]
  )

  const onSamlUsernameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSamlUsername(event.target.value)
  }
  const onOidcUsernameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setOidcUsername(event.target.value)
  }

  const onPhoneChange = (value) => {
    value ? setPhoneNumber(value) : setPhoneNumber('')
  }

  const cancelUserCreation = (e) => {
    e.preventDefault()
    if(onCancel){
      onCancel()
    }
  }

  const submitNewUser = (e) => {
    e.preventDefault()
    setLoading(true)
    const formData: any = {
      "access_scope": userCreationType === CreateUserTypes.DIGICERT_USER,
      "first_name": firstName,
      "last_name": lastName,
      "email": email,
      "user_name": userName,
      "locale": language,
      "phone": phoneNumber,
      "other_phone": '',
      "group_ids": groups
    }

    if(samlUsername) {formData.saml_username= samlUsername}

    if(oidcUsername) {formData.oidc_username= oidcUsername}

    if (certCentralId && selectedSpCertCentralSpAccounts && selectedSpCertCentralSpAccounts.length > 0) {
      formData.service_provider_account_ids = {[certCentralId]: selectedSpCertCentralSpAccounts}
    }

    if (userCreationType === CreateUserTypes.ACCOUNT_USER) {
      formData.accounts = [
        {
          "id": account
        }
      ]
      formData.application_ids = applications
    }

    const userType = userCreationType === CreateUserTypes.DIGICERT_USER ? <Translate id='common.system'/> : <Translate id='common.account'/>

    createUser(formData, <Translate id={'notifications.users.createUser'} data={{ userType: userType, userName: userName }} />).then(() => {
      history.push(RouterConfig.administrators.table)
      if(onCreate){
        onCreate()
      }
      setLoading(false)
    })
  }

  const handleMultiSelect = (value): void => {
    setGroups(value)
  }

  const handleSpMultiSelect = (value): void => {
    setSelectedSpCertCentralSpAccounts(value)
  }

  const validateMultiSelect = (): any => {
    if (groups.length === 0) {
      return <Translate id='common.form.validation.required' />
    }
  }

  const renderCustomMultiSelectOption = (option) => {
    return (
        <div className={styles.customMultiSelectOption}>
          <p className={styles.label}>{option.data.label}</p>
          <p className={styles.description}>{option.data.description}</p>
        </div>
    )
  }

  const selectService = (e: MouseEvent, item: IApplication): void => {
    e.preventDefault()
    const tmpArray:Array<IApplication> = [...selectedServices]
    const tmpAppIds:Array<string> = [...applications]
    const serviceExists = selectedServices.some(service => service.id === item.id)

    if(!serviceExists) {
      tmpArray.push(item)
      tmpAppIds.push(item.id)
      setSelectedServices(tmpArray)
      setApplications(tmpAppIds)
      if(item.short_app_code === CERT_CENTRAL_SHORT_APP_CODE){
        setCertCentralId(item.id)
      }
    }

    else {
      const filterService = tmpArray.filter(service => service.id !== item.id)
      const filterAppIds = tmpAppIds.filter(appId => appId !== item.id)
      setSelectedServices(filterService)
      setApplications(filterAppIds)
      if(item.short_app_code === CERT_CENTRAL_SHORT_APP_CODE){
        setSelectedSpCertCentralSpAccounts([])
        setCertCentralId('')
      }
    }
  }

  useEffect(() => {
    if (userCreationType === CreateUserTypes.ACCOUNT_USER && account !== '' && account !== translate('common.form.select') as string) {
      fetchGroups(IAccessScope.account.toUpperCase()).then(res => {
        const groupOptions = res.map(group => {
          return {
            value: group.id,
            label: translate(`groups.${group.name}`),
            description: translate(`groups.descriptions.${group.name}`)
          }
        })
        setOptions(groupOptions)
      })
    } else if (userCreationType === CreateUserTypes.DIGICERT_USER) {
      fetchGroups(IAccessScope.system.toUpperCase()).then(res => {
        const groupOptions = res.map(group => {
          return {
            value: group.id,
            label: translate(`groups.${group.name}`),
            description: translate(`groups.descriptions.${group.name}`)
          }
        })
        setOptions(groupOptions)
      })
    }
  }, [account, fetchGroups, userCreationType, groups])

  useEffect(() => {
    if(userCreationType === CreateUserTypes.ACCOUNT_USER && profile?.accounts && profile.accounts.length === 1){
      setAccount(profile.accounts[0].id)
      setLanguage(profile.accounts[0].locale)
      fetchTenantById(profile.accounts[0].id).then((tenant: any) => {
        setAppOptions(tenant.applications.map(app => {
          if(app.short_app_code === CERT_CENTRAL_SHORT_APP_CODE) {
            if (app.service_provider_accounts) {
              const spOptions = app.service_provider_accounts.map(acc => {
                return {
                  value: acc.id,
                  label: acc.source_account_name
                }
              })
              setCertCentralSpAccounts(spOptions)
            }
          }
          return {
            label: app.name,
            value: app.id,
            short_app_code: app.short_app_code
          }
        }))
        setSignInMethods(tenant.sign_in_methods)
      })
    }
  }, []);

  useEffect(() => {
    if(userCreationType === CreateUserTypes.DIGICERT_USER) {
      setLanguage('en_US')
    }
  }, []);

  if (permissions.canManageAccountUser
      ? false
      : !permissions.canManageSystemUser) {
    return <NoPermissionsPage />
  }

  async function fetchAccounts(offset: number, accountName: string) {
    return fetchTenants({limit: limit, offset: offset}, {"name": accountName, "active" : true})
    .then((response) => {
      setTotal(response.total)
      const options = response.items.map((account) => {
        return {
          label: account.display_name,
          value: account.id,
          locale: account.locale
        }
      })
      options?.sort((a, b) => (a.label > b.label ? 1 : -1))
      return options;
    })
  }

  const onAccountSearch = (value : string) => {
    setOffset(0)
    if (value && value.length > 2) {
      setAccountName(value);
      fetchAccounts(0, value).then((options) => {
        setAllAccounts(options)
      })
    } else {
      setAllAccounts(accountMessage)
    }
  }

  const onAccountSearchScroll = () => {
    const newOffset = limit + offset
    if(newOffset <= total) {
      setOffset(newOffset)
      fetchAccounts(newOffset, accountName).then((options) => {
        setAllAccounts((prevAccounts) => [...prevAccounts, ...options])
      })
    }
  }

  return (
      <>
        <section className={styles.createUser}>
          <Form center={false} onSubmit={(e) => {submitNewUser(e)}} className={styles.form}>
            {userCreationType === CreateUserTypes.ACCOUNT_USER && (
                <h3 className={styles.headline}><Translate id='manageUser.administrators.form.generalInfo'/></h3>
            )}

            <div className={styles.restrictedFormElements}>
              <FormGroup>
                <div className={styles.nameGroup}>
                  <Input
                      label={translate('common.form.firstName') as string}
                      required
                      minLength={1}
                      maxLength={256}
                      value={firstName}
                      onChange={onFirstNameChange}
                      pattern={NAME_REGEXP}
                      errors={{
                        valueMissing: translate('common.form.validation.required') as string
                      }}
                      id='first_name'
                  />

                  <Input
                      label={translate('common.form.lastName') as string}
                      required
                      minLength={1}
                      maxLength={256}
                      value={lastName}
                      pattern={NAME_REGEXP}
                      onChange={onLastNameChange}
                      id='last_name'
                      errors={{
                        valueMissing: translate('common.form.validation.required') as string
                      }}
                  />
                </div>
              </FormGroup>

              <FormGroup>
                <Input
                    label={<Translate id='common.form.emailAddress'/>}
                    required
                    value={email}
                    onChange={onEmailChange}
                    pattern={EMAIL_REGEXP}
                    errors={{
                      typeMismatch: translate('notifications.errors.invalidEmailError') as string,
                      valueMissing: translate('common.form.validation.required') as string,
                      patternMismatch: translate('notifications.errors.invalidEmailError') as string
                    }}
                />
              </FormGroup>

              <FormGroup>
                <Input
                    label={<Translate id='common.form.username'/>}
                    required
                    value={userName}
                    pattern={USER_NAME_REGEXP}
                    errors={{
                      valueMissing: translate('common.form.validation.required') as string,
                      patternMismatch: translate('common.form.validation.invalidUserName') as string
                    }}
                    onChange={onUserNameChange}
                    onFocus={onUserNameFocus}
                    validate={validateUserName}
                />
              </FormGroup>

              {signInMethods.find(method=>method.signInMethod=== 'singleSignOnSaml' && method.status === 'enabled')  && (
                <FormGroup>
                  <Input
                      label={<Translate id='common.form.samlUsername'/>}
                      required
                      value={samlUsername}
                      pattern={USER_NAME_REGEXP}
                      errors={{
                        valueMissing: translate('common.form.validation.required') as string,
                        patternMismatch: translate('common.form.validation.invalidUserName') as string
                      }}
                      onChange={onSamlUsernameChange}
                      onFocus={onSamlUsernameFocus}
                  />
                </FormGroup>
              )}

              {signInMethods.find(method=>method.signInMethod=== 'singleSignOnOidc' && method.status === 'enabled') && (
                <FormGroup>
                  <Input
                      label={<Translate id='common.form.oidcUsername'/>}
                      required
                      value={oidcUsername}
                      pattern={USER_NAME_REGEXP}
                      errors={{
                        valueMissing: translate('common.form.validation.required') as string,
                        patternMismatch: translate('common.form.validation.invalidUserName') as string
                      }}
                      onChange={onOidcUsernameChange}
                      onFocus={onOidcUsernameFocus}
                  />
                </FormGroup>
              )}

              <FormGroup>
                <Input
                    label={translate('common.form.phoneOptional') as string}
                    type={InputType.TELEPHONE}
                    validateChanges
                    value={phoneNumber}
                    errors={{valueMissing: translate('common.form.validation.required') as string}}
                    onChange={onPhoneChange}
                />
              </FormGroup>

              <div className={styles.accountAccessGroup}>
                {userCreationType === CreateUserTypes.ACCOUNT_USER
                  && ((profile?.accounts && profile.accounts.length > 1) || profileAccessScope === IAccessScope.system) && (
                    <>
                      <h3 className={styles.headline}><Translate id='manageUser.administrators.form.accountAccess'/></h3>
                      <div className={styles.option}>
                          <Select
                              getPopupContainer={(triggerNode) => triggerNode.parentElement}
                              allowClear
                              defaultValue={account}
                              value={account}
                              label={translate('manageUser.administrators.digicertAccount') as string}
                              placeholder={translate('common.search') as string}
                              onChange={onAccountChange}
                              options={allAccounts}
                              optionFilterProp="label"
                              showSearch
                              onSearch={onAccountSearch}
                              onPopupScroll={onAccountSearchScroll}
                              onClear={()=>setSignInMethods([])}
                          />
                      </div>
                    </>
                )}

                {userCreationType === CreateUserTypes.ACCOUNT_USER && profile?.accounts && profile.accounts.length === 1 && (
                    profile.accounts.map((account, index) => {
                      return (
                          <>
                            <h3 className={styles.headline}><Translate id='manageUser.administrators.form.accountAccess'/></h3>
                            <div className={styles.selectedAccount} key={index}>
                              <FontAwesomeIcon icon={faBuilding as IconProp} className={styles.AccountIcon}/>
                              <div className={styles.selectedAccountInfo}>
                                <p className={styles.selectedAccountLabel}>{translate('manageUser.administrators.digicertAccount') as string}</p>
                                <p className={styles.selectedAccountName}>{account.name}</p>
                              </div>
                            </div>
                          </>
                      )
                    })
                )}
              </div>

              {(userCreationType === CreateUserTypes.DIGICERT_USER || userCreationType === CreateUserTypes.ACCOUNT_USER) && options.length > 0 &&
                  <FormGroup>
                    <MultiSelect
                        help=""
                        value={groups}
                        placeholder={translate('common.form.select') as string}
                        onChange={handleMultiSelect}
                        allowClear={true}
                        label={translate('manageUser.administrators.userGroup') as string}
                        size={FormFieldSize.XXL}
                        options={options}
                        validate={validateMultiSelect}
                        optionRender={(option) => (renderCustomMultiSelectOption(option))}
                    />
                  </FormGroup>
              }
            </div>

            {userCreationType === CreateUserTypes.ACCOUNT_USER && appOptions.length > 0 &&
                <div className={styles.availableServices}>
                  <h3><Translate id='accounts.availableServices'/></h3>
                  <CardContainer className={styles.cardContainer}>
                    {getServices().map((item, index) => {
                      return (
                          <Card
                              key={index}
                              className={styles.card}
                              size={CardSizeTypes.SMALL}
                              onClick={(e: MouseEvent) => selectService(e, item)}
                              content={
                                <CardContent>
                                  <div className={styles.cardContent} key={index}>
                                    <div>{serviceIcon(item.name)}</div>
                                    <div className={styles.cardLabel}>{item.name}</div>
                                    <div>
                                      <Checkbox checked={selectedServices.some(service => service.id === item.id)}/>
                                    </div>
                                  </div>
                                </CardContent>}
                          />
                      )
                    })}
                  </CardContainer>
                </div>
            }

            {selectedServices.some(service => service.short_app_code === CERT_CENTRAL_SHORT_APP_CODE) && certCentralSpAccounts &&
                <FormGroup>
                  <MultiSelect
                      help=""
                      value={selectedSpCertCentralSpAccounts}
                      placeholder={translate('common.form.select') as string}
                      onChange={handleSpMultiSelect}
                      allowClear={true}
                      label={translate('manageUser.administrators.certCentralAccount') as string}
                      size={FormFieldSize.XXL}
                      options={certCentralSpAccounts}
                  />
                </FormGroup>
            }

            <div className={styles.formActions}>
              <Button buttonType={ButtonType.SECONDARY} onClick={cancelUserCreation}>
                <Translate id='common.form.buttons.cancelBtn'/>
              </Button>

              <SubmitButton
                disabled={
                  userCreationType !== CreateUserTypes.DIGICERT_USER && !account
                  || userCreationType !== CreateUserTypes.DIGICERT_USER && selectedServices.length === 0
                  || userCreationType !== CreateUserTypes.DIGICERT_USER && account === translate('common.form.select') as string
                  || isLoading}>
                {translate('common.form.buttons.createUser') as string}
              </SubmitButton>
            </div>
          </Form>
        </section>
      </>
  )
}

export default connect((state: IAppState) => ({
      profile: state.profile.data
    }),
    {createUser, checkIfUsernameExists, fetchGroups, fetchTenants, fetchTenantById}
)(CreateUserWithRole)
